import {
  createFuelOutown,
  getUserAccountList,
  handleKeyDown,
  uploadFiles,
} from "_services";
import { getFuelStationListData } from "_services/accountsServices/fuelStationServices";
import { getFuelApi } from "_services/dropdownServices/dropdownService";
import {
  CommonCanvas,
  CommonDatePicker,
  CommonInput,
  CommonModal,
  CustomSelect,
  SkeletonInput,
} from "components";
import { UserContext } from "context";
import { addFuelTransaction, addTransationFreight } from "features";
import { errorSchema, utils } from "helper";
import AddEditFuelStation from "modals/AddEditFuelStation";
import moment from "moment";
import Loading from "pages/Loading";
import React, { useContext, useEffect, useMemo, useState } from "react";
import toast from "react-hot-toast";
import { IoCloseCircle } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { getAllPermissions } from "utils/permissionHelper";
import StorageService from "utils/StorageServices/StorageServices";

const arryOptions = [
  { label: "Arjun", value: "01" },
  { label: "Anvit", value: "02" },
];

const AddFuelOwn = (props) => {
  const { getData, closeModal, callBackFreight, transactionList } = props;

  const initiFrom = {
    category: "",
    sub_category: "",
    fuel_station_id: "",
    account_category: "",
    account_sub_category: "",
    account_id: "",
    fuel_ltr: "",
    fuel_rate: "",
    amount: "",
    date: new Date(),
    description: "",
    slip_no: "",
    transaction_no: "",
    vendor_type: "",
    vendor_id: "",
    vendor_bank_account: "",
    trip_id: "",
    branch_id: "",
    company_id: StorageService?.getCompanyId(),
    vehicle_id: "",
    file: [],
    is_approval: "",
  };

  const { masterData, globTripDetails, allMenu } = useContext(UserContext);
  const dispatch = useDispatch();
  const [form, setForm] = useState(initiFrom);
  const [formError, setFormError] = useState("");
  const [isLoadding, setIsLoadding] = useState(false);
  const [fuelStationList, setFuelStationList] = useState([]);
  const [filter, setFilter] = useState({
    limit: 10,
    offset: 1,
    search: "",
    status: 1,
  });

  const [freightTypeList, setFreightTypeList] = useState([]);
  const [freigtAccount, setFreigtAccount] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoadingSave, setIsLoadingSave] = useState(false);
  const [accountList, setAccountList] = useState([]);
  const [accountLoading, setAccountLoading] = useState(false);
  const [showOffcanvasFuel, setShowOffcanvasFuel] = useState(false);
  const balance = props?.transactionList?.freight_summary?.balance;
  const hasLinkCharofAccountPermission = getAllPermissions("Fuel Station", allMenu, 'label');


  useEffect(() => {
    getMasterFreight();
  }, []);

  useEffect(() => {
    if (form?.sub_category == 1) {
      getDataFuelStationList();
    }
    if (form?.sub_category == 2) {
      getAccountListHandler(2);
    }
    if (form?.sub_category == 3) {
      getAccountListHandler(3);
    }
  }, [form?.sub_category]);

  const getMasterFreight = async () => {
    const payload = {
      type: "add_freight",
    };

    try {
      const details = masterData?.supplier_fuels?.sub_type?.map((item) => {
        return {
          label: item?.name,
          value: item?.id,
          id: item?._id,
          status: item?.status,
          category_id: masterData?.supplier_fuels?.id,
          type: masterData?.supplier_fuels?.type,
        };
      });
      if (details) {
        setForm({
          ...form,
          category: parseInt(details[0]?.category_id),
          sub_category: parseInt(details[0]?.value),
        });
        setFreightTypeList(details);
      }
      // }
    } catch { }
  };

  const handleOnChange = async (name, value) => {
    const updatedForm = {
      ...form,
      [name]: value,
    };

    setForm((prevForm) => {
      const updatedForm = {
        ...prevForm,
        [name]: value,
      };

      if (name === "fuel_ltr" || name === "fuel_rate") {
        if (updatedForm.fuel_ltr && updatedForm.fuel_rate) {
          updatedForm.amount = (
            parseFloat(updatedForm.fuel_ltr) * parseFloat(updatedForm.fuel_rate)
          ).toFixed(2); // Calculate amount if both fuel_ltr and fuel_rate are present
        } else {
          updatedForm.amount = ""; // Reset amount if either value is missing
        }
      } else if (name === "amount") {
        if (updatedForm.fuel_rate) {
          if (updatedForm.amount) {
            updatedForm.fuel_ltr = (
              parseFloat(updatedForm.amount) / parseFloat(updatedForm.fuel_rate)
            ).toFixed(2); // Calculate fuel_ltr if amount and fuel_rate are present
          } else {
            updatedForm.fuel_ltr = ""; // Reset fuel_ltr if amount is missing
          }
        } else if (updatedForm.fuel_ltr) {
          if (updatedForm.amount) {
            updatedForm.fuel_rate = (
              parseFloat(updatedForm.amount) / parseFloat(updatedForm.fuel_ltr)
            ).toFixed(2); // Calculate fuel_rate if amount and fuel_ltr are present
          } else {
            updatedForm.fuel_rate = ""; // Reset fuel_rate if amount is missing
          }
        }
      } else if (
        name === "fuel_ltr" &&
        updatedForm.amount &&
        updatedForm.fuel_rate
      ) {
        updatedForm.amount = (
          parseFloat(updatedForm.fuel_ltr) * parseFloat(updatedForm.fuel_rate)
        ).toFixed(2); // Recalculate amount when fuel_ltr is changed
      } else if (
        name === "fuel_rate" &&
        updatedForm.amount &&
        updatedForm.fuel_ltr
      ) {
        updatedForm.amount = (
          parseFloat(updatedForm.fuel_ltr) * parseFloat(updatedForm.fuel_rate)
        ).toFixed(2); // Recalculate amount when fuel_rate is changed
      }

      return updatedForm;
    });

    // setForm(updatedForm);

    if (!!formError) {
      const validationResult = await utils.checkFormError(
        {
          ...form,

        },
        errorSchema.addFuelSchema
      );
      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const onSubmitFuel = async (approve) => {
    const validationResult = await utils.checkFormError(
      { ...form },
      errorSchema.addFuelSchema
    );

    const payload = {
      type: form?.category,
      sub_type: parseInt(form?.sub_category),
      fuel_station_id: form?.fuel_station_id,
      account_category: form?.account_category,
      account_sub_category: form?.account_sub_category,
      account_id: form?.account_id,
      fuel_ltr: form?.fuel_ltr,
      fuel_rate: form?.fuel_rate,
      amount: form?.amount,
      date: utils.convertToISO(form?.date, true),
      description: form?.description,
      slip_no: form?.slip_no,
      transaction_no: form?.transaction_no,
      branch_id: "",
      company_id: form?.company_id,
      vehicle_id: getData?._id,
      file: form?.file,
      is_approval: approve,
    };

    if (validationResult === true) {

      approve == 0 ? setIsLoadingSave(true) : setIsLoadding(true);

      try {

        const res = await createFuelOutown(payload);

        if (res?.responseCode === 200) {
          setIsLoadding(false);
          setIsLoadingSave(false);
          closeModal();
          callBackFreight();
        } else {
          setIsLoadding(false);
          setIsLoadingSave(false);
        }
      } catch {
        setIsLoadding(false);
        setIsLoadingSave(false);
      }
    } else {
      setIsLoadding(false);
      setIsLoadingSave(false);
      setFormError(validationResult);
    }
  };

  const getDataFuelStationList = async () => {
    try {
      setAccountLoading(true);
      let object = {
        ...filter,
        company_id: StorageService.getCompanyId(),
      };
      const res = await getFuelApi(object);
      if (res?.responseCode == 200) {
        setAccountLoading(false);
        const list = res?.data?.fuelstation_list?.map((item) => {
          return {
            ...item,
            label: item?.name,
            value: item?._id,
          };
        });
        setFuelStationList(list);
        setForm({
          ...form,
          fuel_station_id: list[0]?.value,
          account_id: "",
          account_category: "",
          account_sub_category: "",
        });
        //           handleOnChange("fuel_station_id", list[0]?.value);
        // handleOnChange("account_id", "");
        // handleOnChange("account_category", "");
        // handleOnChange("account_sub_category", "");
      } else {
        setAccountLoading(false);
        setAccountList([]);
      }
    } catch (error) {
      setAccountLoading(false);
      setAccountList([]);
      // throw error;
    }
  };

  const getAccountListHandler = async (acc) => {
    setAccountLoading(true);
    try {
      const res = await getUserAccountList({
        company_id: StorageService?.getCompanyId(),
        category_id: 1,
        sub_category_id: acc == 2 ? 12 : 3,
        account_id: "",
      });

      if (res?.responseCode === 200) {
        setAccountLoading(false);
        const details = res?.data?.account_list?.map((item) => {
          return {
            label: item?.name,
            value: item?.id,
          };
        });
        setAccountList(details);
        // handleOnChange("account_id", details[0].value);
        // handleOnChange("fuel_station_id", "");
        setForm({
          ...form,
          account_id: details[0].value,
          fuel_station_id: "",
          account_category: 1,
          account_sub_category: acc == 2 ? 12 : 3,
        });

        // handleOnChange("fuel_station_id",'');
        // handleOnChange("account_id", details[0].value);
        // handleOnChange("account_category",1);
        // handleOnChange("account_sub_category", 3);
      } else {
        setAccountLoading(false);
        setForm({
          ...form,
          account_id: "",
          fuel_station_id: "",
          account_category: 1,
          account_sub_category: acc == 2 ? 12 : 3,
        });
      }
    } catch (error) {
    }
  };



  const handleFileChange = async (e) => {
    if (
      e?.target?.files[0]?.type === "image/gif" ||
      e?.target?.files[0]?.type === "image/jpeg" ||
      e?.target?.files[0]?.type === "image/png"
    ) {
      setLoading(true);
      try {
        const formData = new FormData();
        formData.append("file", e?.target?.files[0]);
        const res = await uploadFiles(formData);
        if (res?.responseCode === 200) {
          var fileArray = [];
          fileArray.push(...form?.file, {
            filename: res?.data?.filename,
            path: res?.data?.path,
          });
          handleOnChange("file", fileArray);
          // setFormValue((s) => ({ ...s, file: fileArray }));
          setLoading(false);
          toast.success("Document added ");
        }
      } catch (error) {
        setLoading(false);
      }
    } else {
      toast.error("Invalid file, choose jpeg/png images");
    }
  };

  const documentRemove = (index) => {
    const newFromIput = [...form?.file];

    newFromIput.splice(index, 1);

    setForm({ ...form, file: newFromIput });
  };

  const addNewItemHandler = () => {
    setShowOffcanvasFuel(true);
  };

  const callBackFuel = (data) => {
    setForm({ ...form, fuel_station_id: data?._id });
    getDataFuelStationList();
  };

  const modifyProps = {
    ...props,
    isLoadding: isLoadding,
    disabled: isLoadding,
    isLoadingSave: isLoadingSave,
    onSubmit: onSubmitFuel,
  };

  return (
    <div>
      <CommonCanvas {...modifyProps}>
        <div className="offcanvas-body">
          <div className="_lrCl_offCavBody">
            <div className="checkBx_lv">
              {getData?.vehicle_ownership != 2 || globTripDetails?.vehicle_ownership != 2 && (
                <>
                  {freightTypeList.map((i) => {
                    return (
                      <div className="_dualCheckr_bx">
                        <input
                          className="form-check-input"
                          id={i?.value}
                          type="radio"
                          name="sub_category"
                          checked={i.value == form.sub_category}
                          value={i.value}
                          // disabled={i.value==2}
                          onChange={({ target: { name, value } }) =>
                            handleOnChange(name, parseInt(value))
                          }
                        />
                        <label for={i?.value} className="form-check-label">
                          {i?.label}
                        </label>
                      </div>
                    );
                  })}
                </>
              )}
            </div>

            <div className="addFreight_body">
              <div className="_clPay_flex">
                <div className="singleDiv">
                  {form?.sub_category == 1 && (
                    <>
                      {!accountLoading ? (
                        <CustomSelect
                          label="Fuel Station"
                          // options={arryOptions}
                          options={
                            fuelStationList
                              ? fuelStationList
                              : { label: "", value: "" }
                          }
                          onSelect={(data) => {
                            handleOnChange("fuel_station_id", data.value);
                          }}
                          value={
                            form?.fuel_station_id
                              ? fuelStationList?.find(
                                (i) => i.value == form?.fuel_station_id
                              )
                              : { label: "", value: "" }
                          }
                          isAddButton={hasLinkCharofAccountPermission.canCreate ? true : false}
                          addButtonAction={(e) => addNewItemHandler(e)}
                          focus={!!formError?.fuel_station_id}
                          error={formError.fuel_station_id}
                        />
                      ) : (
                        <SkeletonInput isLoading={accountLoading} />
                      )}
                    </>
                  )}

                  {form?.sub_category != 1 && (
                    <CustomSelect
                      label="Account"
                      // options={arryOptions}
                      options={
                        accountList ? accountList : { label: "", value: "" }
                      }
                      onSelect={(data) => {
                        handleOnChange("account_id", data.value);
                      }}
                      value={
                        form?.account_id
                          ? accountList?.find(
                            (i) => i.value == form?.account_id
                          )
                          : { label: "", value: "" }
                      }
                      focus={!!formError?.account_id}
                      error={formError.account_id}
                    />
                  )}
                </div>

                <div className="singleDiv">
                  <div className="flxInr">
                    <div className="halfDiv">
                      <CommonInput
                        type="text"
                        label="LTR"
                        placeholder="LTR"
                        name="fuel_ltr"
                        value={form?.fuel_ltr}
                        onChange={({ target: { name, value } }) => {
                          const validValue = value.replace(/[^0-9.]/g, "");
                          const formattedValue = validValue.includes(".")
                            ? validValue.split(".")[0] +
                            "." +
                            validValue.split(".")[1].slice(0, 2)
                            : validValue;
                          handleOnChange(name, formattedValue);
                        }}
                        focus={!!formError?.fuel_ltr}
                        error={formError.fuel_ltr}
                        onKeyDown={handleKeyDown}
                        maxLength={5}
                      />
                    </div>

                    <div className="halfDiv">
                      <CommonInput
                        type="text"
                        label="Rate"
                        placeholder="Rate"
                        name="fuel_rate"
                        value={form?.fuel_rate}
                        onChange={({ target: { name, value } }) => {
                          const validValue = value.replace(/[^0-9.]/g, "");
                          const formattedValue = validValue.includes(".")
                            ? validValue.split(".")[0] +
                            "." +
                            validValue.split(".")[1].slice(0, 2)
                            : validValue;
                          handleOnChange(name, formattedValue);
                        }}
                        focus={!!formError?.fuel_rate}
                        error={formError.fuel_rate}
                        onKeyDown={handleKeyDown}
                        maxLength={5}
                      />
                    </div>
                  </div>
                </div>

                <div className="singleDiv">
                  <CommonInput
                    type="text"
                    label="Amount (₹)"
                    placeholder="Amount (₹)"
                    name="amount"
                    value={form.amount}
                    onChange={({ target: { name, value } }) => {
                      const validValue = value.replace(/[^0-9.]/g, "");
                      const formattedValue = validValue.includes(".")
                        ? validValue.split(".")[0] +
                        "." +
                        validValue.split(".")[1].slice(0, 2)
                        : validValue;
                      handleOnChange(name, formattedValue);
                    }}
                    onKeyDown={handleKeyDown}
                    focus={!!formError?.amount}
                    error={formError.amount}
                    maxLength={7}
                  />
                  <p className="_bottomPLine">
                    This entry will be marked credit for Fuel Station
                  </p>
                </div>

                <div className="singleDiv">
                  <CommonDatePicker
                    name="date"
                    label=" Date"
                    startDate={form?.date}
                    setStartDate={(data) => {
                      handleOnChange("date", data);
                    }}
                    error={formError?.date}
                    focus={!!formError?.date}
                  />
                </div>

                <div className="singleDiv">
                  <CommonInput
                    type="text"
                    label="Description"
                    placeholder="Description"
                    name="description"
                    value={form?.description}
                    onChange={({ target: { name, value } }) => {
                      handleOnChange(name, value);
                    }}
                    focus={!!formError?.description}
                    error={formError.description}
                  />
                </div>

                {parseInt(form?.sub_category) == 1 && (
                  <div className="singleDiv">
                    <CommonInput
                      type="text"
                      label="Slip Number"
                      placeholder="Slip Number"
                      name="slip_no"
                      value={form?.slip_no}
                      onChange={({ target: { name, value } }) => {
                        const cleanValue = value.replace(/[^a-zA-Z0-9]/g, '');
                        handleOnChange(name, cleanValue);
                      }}
                      focus={!!formError?.slip_no}
                      error={formError.slip_no}
                      maxLength={10}
                    />
                  </div>
                )}

                {parseInt(form?.sub_category) == 2 && (
                  <div className="singleDiv">
                    <CommonInput
                      type="text"
                      label="Transaction Number"
                      placeholder="Transaction Number"
                      name="transaction_no"
                      value={form?.transaction_no}
                      onChange={({ target: { name, value } }) => {
                        const cleanValue = value.replace(/[^a-zA-Z0-9]/g, '');
                        handleOnChange(name, cleanValue);
                      }}
                      focus={!!formError?.transaction_no}
                      error={formError.transaction_no}
                      maxLength={10}
                    />
                  </div>
                )}

                <div className="singleDiv">
                  <div className="_attatchmentBxs">
                    <h4>Attachment</h4>

                    <div className="_athBxs">
                      <input
                        type="file"
                        id="_fileUpload"
                        onChange={(e) => handleFileChange(e)}
                        disabled={loading || form?.file?.length >= 5}
                      />
                      <label htmlFor="_fileUpload" className="_uploadBtn">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="19"
                          viewBox="0 0 20 19"
                          fill="none"
                        >
                          <path
                            d="M5 0C6.28846 7.44425e-05 7.52716 0.497542 8.45778 1.38866C9.38839 2.27978 9.93908 3.49575 9.995 4.783L10 5V16C10.0008 16.7809 9.69698 17.5313 9.15323 18.0918C8.60948 18.6523 7.86861 18.9787 7.08804 19.0016C6.30747 19.0245 5.54873 18.7422 4.97303 18.2145C4.39733 17.6869 4.05006 16.9556 4.005 16.176L4 16V6C4.00028 5.74512 4.09788 5.49997 4.27285 5.31463C4.44782 5.1293 4.68695 5.01776 4.94139 5.00283C5.19584 4.98789 5.44638 5.07067 5.64183 5.23426C5.83729 5.39785 5.9629 5.6299 5.993 5.883L6 6V16C6.00028 16.2549 6.09788 16.5 6.27285 16.6854C6.44782 16.8707 6.68695 16.9822 6.94139 16.9972C7.19584 17.0121 7.44638 16.9293 7.64183 16.7657C7.83729 16.6021 7.9629 16.3701 7.993 16.117L8 16V5C8.00075 4.21909 7.69698 3.46867 7.15323 2.90818C6.60948 2.34769 5.86861 2.02132 5.08804 1.9984C4.30747 1.97548 3.54873 2.25784 2.97303 2.78546C2.39733 3.31309 2.05006 4.0444 2.005 4.824L2 5V14C1.99972 14.2549 1.90212 14.5 1.72715 14.6854C1.55218 14.8707 1.31305 14.9822 1.05861 14.9972C0.804163 15.0121 0.553621 14.9293 0.358167 14.7657C0.162714 14.6021 0.0371036 14.3701 0.00699997 14.117L0 14V5C0 3.67392 0.526784 2.40215 1.46447 1.46447C2.40215 0.526784 3.67392 0 5 0ZM13 14H15C15.2549 14.0003 15.5 14.0979 15.6854 14.2728C15.8707 14.4478 15.9822 14.687 15.9972 14.9414C16.0121 15.1958 15.9293 15.4464 15.7657 15.6418C15.6021 15.8373 15.3701 15.9629 15.117 15.993L15 16H13C12.7451 15.9997 12.5 15.9021 12.3146 15.7272C12.1293 15.5522 12.0178 15.313 12.0028 15.0586C11.9879 14.8042 12.0707 14.5536 12.2343 14.3582C12.3979 14.1627 12.6299 14.0371 12.883 14.007L13 14ZM13 10H18.5C18.7549 10.0003 19 10.0979 19.1854 10.2728C19.3707 10.4478 19.4822 10.687 19.4972 10.9414C19.5121 11.1958 19.4293 11.4464 19.2657 11.6418C19.1021 11.8373 18.8701 11.9629 18.617 11.993L18.5 12H13C12.7451 11.9997 12.5 11.9021 12.3146 11.7272C12.1293 11.5522 12.0178 11.313 12.0028 11.0586C11.9879 10.8042 12.0707 10.5536 12.2343 10.3582C12.3979 10.1627 12.6299 10.0371 12.883 10.007L13 10ZM13 6H18.5C18.7549 6.00028 19 6.09788 19.1854 6.27285C19.3707 6.44782 19.4822 6.68695 19.4972 6.94139C19.5121 7.19584 19.4293 7.44638 19.2657 7.64183C19.1021 7.83729 18.8701 7.9629 18.617 7.993L18.5 8H13C12.7451 7.99972 12.5 7.90212 12.3146 7.72715C12.1293 7.55218 12.0178 7.31305 12.0028 7.05861C11.9879 6.80416 12.0707 6.55362 12.2343 6.35817C12.3979 6.16271 12.6299 6.0371 12.883 6.007L13 6ZM13 2H18.5C18.7549 2.00028 19 2.09788 19.1854 2.27285C19.3707 2.44782 19.4822 2.68695 19.4972 2.94139C19.5121 3.19584 19.4293 3.44638 19.2657 3.64183C19.1021 3.83729 18.8701 3.9629 18.617 3.993L18.5 4H13C12.7451 3.99972 12.5 3.90212 12.3146 3.72715C12.1293 3.55218 12.0178 3.31305 12.0028 3.05861C11.9879 2.80416 12.0707 2.55362 12.2343 2.35817C12.3979 2.16271 12.6299 2.0371 12.883 2.007L13 2Z"
                            fill="#1956F6"
                          />
                        </svg>
                        <span>{loading ? "Uploadding" : "Add File"}</span>
                      </label>
                      {formError?.file && (
                        <span className="input_drop_error">
                          {formError?.file}
                        </span>
                      )}
                    </div>
                    <div className="img_fnex_src">
                      {form?.file?.length > 0 &&
                        form?.file?.map((el, index) => {
                          return (
                            <>
                              <div className="pos-relative">
                                <img
                                  className="_pdfIcon_sigxe"
                                  src={`${masterData?.s3_url}${el?.path}`}
                                  alt=""
                                />
                                <span className="_clDel_icon">
                                  <IoCloseCircle
                                    onClick={() => documentRemove(index)}
                                  />
                                </span>
                              </div>
                            </>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {globTripDetails?.vehicle_ownership == 2 && (
          <div className="_balSuccess">
            <p>Balance</p>

            <p>
              {(
                props?.transactionList?.freight_summary?.balance - form?.amount
              )?.toFixed(2)}
            </p>
          </div>
        )}
      </CommonCanvas>
      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasFuel ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: showOffcanvasFuel ? "visible" : "hidden" }}
      >
        {showOffcanvasFuel && (
          <AddEditFuelStation
            isOpen={showOffcanvasFuel}
            onClose={(e) => setShowOffcanvasFuel(false)}
            callBackFuel={callBackFuel}
            hideAddNewOption={false}
            branchFirmId={StorageService?.getFirmId()}

          />
        )}
      </div>
      <div className={showOffcanvasFuel ? "offBack_drop" : ""}></div>
    </div>


  );
};

export default AddFuelOwn;
